import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AuthenticateService } from '../services/authentication.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ModalController, AlertController } from '@ionic/angular';
import { serie } from 'src/model/Serie';
import { format, compareAsc, add } from 'date-fns';
import formatdata from 'date-fns/format';
import { addMinutes, isAfter } from 'date-fns';

// import addmin from 'date-fns/fp'; 
// import addMinutes from 'date-fns';

@Component({
  selector: 'app-generaslot',
  templateUrl: './generaslot.page.html',
  styleUrls: ['./generaslot.page.scss'],
})
export class GeneraslotPage implements OnInit {
  validations_form: FormGroup;
  @Input() idgara: string;
  @Input() action: string;
  @Input() idserie: string;
  serie: serie = new serie();
  constructor(private fireStore: AngularFirestore, public auth: AuthenticateService, public formBuilder: FormBuilder, public modal: ModalController,
    private alertController: AlertController) { }

  ngOnInit() {
    this.validations_form = new FormGroup({
      data_a: new FormControl(),
      slot: new FormControl(),
      campo: new FormControl(),
      data_da: new FormControl()
    });
  }
  close() {
    this.modal.dismiss();
  }

  aux_date;

  recursive(dat, at) {

  }
  date_arr = [];
  avvia_creazione() {

    // //console.logaddMinutes(this.validations_form.value.data_da,10));


    // //console.logthis.setdate(this.validations_form.value.data_da,1,this.validations_form.value.slot));
    if (this.aux_date == undefined || this.aux_date == null)
      this.aux_date = this.validations_form.value.data_da;

    if (!isAfter(this.setdate(this.aux_date, 2), this.setdate(this.validations_form.value.data_a, 2))) {
      var da = this.aux_date;
      var a = this.setdate(da, 1, this.validations_form.value.slot).replace('!', 'T') + '+02:00';
      this.date_arr.push({ da: da, a: a });
      this.aux_date = a;
      // this.crea(da, a);
      this.avvia_creazione();
    }
    else {
      //console.logthis.date_arr);
      this.crea_confirm();
      return;
    }



  }

  async crea_confirm() {
    if (this.date_arr.length > 25) {
      alert('NUMERO DI SLOT TROPPO ALTO');
    }
    else {
      const alert = await this.alertController.create({
        header: 'Creazione slot massiva',
        message: 'Sei sicuro di voler <strong>creare ' + this.date_arr.length + '</strong> slot?',
        buttons: [
          {
            text: 'Annulla',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {

            }
          }, {
            text: 'Si, crea',
            handler: () => {
              this.date_arr.forEach((el) => {
                this.crea(el.da, el.a);
              })

              this.close();
            }
          }
        ]
      });

      await alert.present();
    }
  }

  crea(da, a) {

    this.serie.data_da = da;
    this.serie.data_a = a;
    this.serie.campo = this.validations_form.value.campo;
    this.serie.punteggi = [];
    this.serie.tiratore1 = [];
    this.serie.tiratore2 = [];
    this.serie.tiratore3 = [];
    this.serie.tiratore4 = [];
    this.serie.tiratore5 = [];
    this.serie.tiratore6 = [];
    this.serie.tiratori = [];
    this.serie.id_gara = this.idgara;

    let obj = {};
    for (let p in this.serie) {
      obj[p] = this.serie[p];
    }
    this.fireStore.collection<any>('serie').add(obj).then(() => {
    })
  }



  setdate(d, format, durata?) {
    //return d.substring(0, d.length - 3);

    if (d != undefined) {
      var today = 'DD MM YY';
      var format1 = 'dddd, DD MMM, YYYY - H:mm';
      var format2 = 'H:mm';
      var format3 = 'dddd, DD MMM, YYYY';
      var format4 = 'dddd, DD MMM  H:mm';
      var format5 = 'dd/MM/yyyy HH:mm';
      var format6 = 'yyyy-MM-dd!HH:mm:ss.SSS';
      //             2020-04-07T20:43:01.548+02:00
      var retdata: any;
      var hour = d.substring(11, 13);
      var min = d.substring(14, 16);
      var year = d.substring(0, 4);
      var month = d.substring(5, 7);
      var day = d.substring(8, 10);

      if (format == 1) {
        var datex: Date = new Date(year, month - 1, day, hour, min);
        retdata = formatdata(addMinutes(datex, durata), format6);
        // retdata =addMinutes(datex,20);
        // if (durata > 0)
        //     retdata = formatdata(new Date(year, month - 1, day, hour, min), format1) + ' - ' + formatdata(addMinutes(d, durata), format5);
        // else
        //     retdata = formatdata(new Date(year, month - 1, day, hour, min), format1);
      }

      else if (format == 2) {
        retdata = new Date(year, month - 1, day, hour, min);
      }

      if (format == 3)
        retdata = formatdata(new Date(year, month - 1, day, hour, min), format3)
      else if (format == 4)
        retdata = formatdata(new Date(year, month - 1, day, hour, min), format4);
      else if (format == 5)
        retdata = formatdata(new Date(), today);
      else if (format == 6)
        retdata = day + '/' + month + '/' + year + ' ' + hour + ':' + min;
      else if (format == 7)
        retdata = hour + ':' + min;
      else if (format == 8)
        retdata = day + '/' + month + '/' + year;


      //retdata = moment(d).format('dd DD MMM YYYY - hh:mm') + ' to '+ moment(d).add(durata,'minutes').format('hh:mm');
      return retdata;
    }
  }
}
